<script>

import SampleListItem from '@/components/SampleListItem'

export default {
  mixins: [ SampleListItem ],
  data () {
    return {
      isVisible: true
    }
  },
  methods:
  {
    animate () {
      // this.update()
      // this.requestId = raf(this.animate)
    },
    update () {
      // const r = this.$el.getBoundingClientRect()
      // const margin = 10
      // let isVisible = r.top < (window.innerHeight - margin) && r.bottom > margin
      // if (isVisible && !this.isVisible) {
      //   this.$el.classList.add('is-visible')
      //   this.isVisible = true
      // } else if (!isVisible && this.isVisible) {
      //   this.$el.classList.remove('is-visible')
      //   this.isVisible = false
      // }
    },
    unanimate () {
      // if (this.requestId != null) {
      //   raf.cancel(this.animate)
      // }
    }
  },
  mounted () {
    this.animate()
  },
  beforeDestroy () {
    this.unanimate()
  }
}
</script>

<style lang="stylus">

.HomeSearchResults .SampleListItem
  // position relative
  position absolute
  top 0
  left 0
  width 100%

  a

    opacity 1

.show-sample .SampleListItem a
  opacity 1

// .SampleListItem

//   pointer-events none
//   visibility hidden

//   a
//     display none

//   &.is-visible

//     pointer-events auto
//     visibility visible

//     a
//       display block

</style>
